import { stumble } from './stumble';

/**
 * This function is useful when you want to handle a type guard miss.
 * It is typically used in filter or map functions to ensure that all values in a list are always correct.

 * @example
 * const isHagfish = (x: Fish): x is Hagfish => x.spine === false;
 * // This will stumble if any fish is not a hagfish
 * const hagFish: HagFish[] = fish.filter(stumbleOnGuardMiss(isHagfish));
 */
export const stumbleOnGuardMiss =
  <X, Y extends X>(guard: (x: X) => x is Y, message?: string) =>
  (x: X): x is Y => {
    const isY = guard(x);
    if (!isY) {
      stumble(message ?? 'Typeguard did not match expected type');
    }
    return isY;
  };
